import { LoginField } from "..//components/LoginField";
import { MdEdit } from "react-icons/md";
import ToggleIconButton from "../../../components/buttons/toggleIconButton";
import { MdUpload } from "react-icons/md";
import { useTheme } from "../../../context/useThemeContext";

export function EditLoginField(props: {
    fieldTitle: string;
    fieldID: string;
    fieldType: React.HTMLInputTypeAttribute;
    disabled?: boolean;
    defaultValue?: string;
    value?: string;
    invalidInput?: boolean;
    errorMessage?: string;
    minLength?: number;
    disableSpaces?: boolean;
    children?: React.ReactNode;
    clickedEditButton?: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
    const { theme } = useTheme();

    function getValue() {
        if (props.fieldType === "password" && props.disabled) {
            return "dummypassword";
        }

        return props.value;
    }

    return (
        <div style={{ pointerEvents: props.disabled ? "none" : "auto" }}>
            <LoginField
                fieldTitle={props.fieldTitle}
                fieldID={props.fieldID}
                fieldType={props.fieldType}
                value={getValue()}
                disabled={props.disabled}
                onChange={props.onChange}
                invalidInput={props.invalidInput}
                errorMessage={props.errorMessage}
            >
                <ToggleIconButton
                    alt={props.disabled ? "Edit" : "Save"}
                    icon={
                        props.disabled ? (
                            <MdEdit size="18" />
                        ) : (
                            <MdUpload size="18" />
                        )
                    }
                    size={{ x: 40, y: 60 }}
                    inactiveBGColor={
                        props.disabled
                            ? "rgba(255, 255, 255, 0.15)"
                            : theme.accentColor
                    }
                    hoverBGInactive={
                        props.disabled
                            ? "rgba(255,255,255,.35)"
                            : theme.accentColor
                    }
                    className="duration-10 pointer-events-auto ml-2 h-full w-[40px] transition-all ease-in-out"
                    onClick={() => {
                        props.clickedEditButton();
                    }}
                />
            </LoginField>
        </div>
    );
}
